import React from "react";
import { useField } from "formik";
import CustomSelect from "../Select";
import { Option } from "../../types";
import { convertToCapitalize } from "../../utils";

interface FormSelectProps {
  label?: string;
  name: string;
  placeholder?: string;
  id?: string;
  labelClassName?: string;
  className?: string;
  error?: string;
  required?: boolean;
  customElement?: React.ReactNode;
  disabled?: boolean;
  options: Option[];
  [key: string]: any; // To allow additional props
  handleChange?: CallableFunction;
  isClearable?: boolean;
  isMulti?: boolean;
  handleInputChange?: (value: any) => void;
}

const FormSelect: React.FC<FormSelectProps> = ({
  label,
  name,
  placeholder = "",
  id = "",
  labelClassName,
  className,
  error,
  required,
  customElement = null,
  disabled = false,
  options,
  handleChange,
  isClearable = false,
  isMulti = false,
  handleInputChange,
  ...props
}) => {
  const [field, meta, helpers] = useField(name);

  const onChange = (selectedOption: Option | Option[] | null) => {
    helpers.setValue(selectedOption);
    if (handleChange && typeof handleChange === "function") {
      handleChange(selectedOption);
    }
  };

  return (
    <div className={`form-select w-full ${className}`}>
      <div className="relative">
        <CustomSelect
          {...props}
          id={id}
          label={label}
          required={required}
          name={name}
          placeholder={convertToCapitalize(placeholder)}
          options={options}
          value={field.value}
          onChange={onChange}
          labelClassName={labelClassName}
          disabled={disabled}
          isClearable={isClearable}
          isMulti={isMulti}
          handleInputChange={handleInputChange}
          error={error || (meta.touched ? meta.error : "")}
          className={
            error || (meta.touched && meta.error) ? "error border-danger" : ""
          }
        />
        {customElement}
      </div>
    </div>
  );
};

export default FormSelect;
